import React, { useEffect, useState, useCallback } from "react";
import { useRouter } from "../../hooks/router";
import { Container, Title } from "./styles";
import { producaov2 as api } from "../../services/apis";
import ProjetosTable from "./components/ProjetosTable";
import Controls from "./components/Controls";

const ControleProjetos = (props) => {
  const [espera, setEspera] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const doSearches = useCallback(() => {
    const params = {};

    if (page) {
      params.page = page;
    }

    api
      .get("/admin/lista-espera", {
        params,
      })
      .then((res) => {
        const { items, page, pages } = res.data;

        setEspera(items);
        setPage(page);
        setPages(pages);
      });
  }, [page]);

  useEffect(() => {
    doSearches();
  }, [page]);

  return (
    <Container>
      <Controls
        page={page}
        pages={pages}
        doSearches={doSearches}
        handleChange={handleChange}
      />

      <ProjetosTable espera={espera} />

      <Controls
        page={page}
        pages={pages}
        doSearches={doSearches}
        handleChange={handleChange}
      />
    </Container>
  );
};

export default ControleProjetos;
